function AppleAuthWrapper() {
    return null;
}

export default AppleAuthWrapper;
